<template>
    <b-card no-body>
        <b-modal id="upload" title="Dosya Yükle" no-close-on-esc no-close-on-backdrop>
            <excuse-document-upload v-model="excuse"></excuse-document-upload>
            <template #modal-footer><v-executer :loading="uploading" text="Yükle" :action="uploadFile"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    name="excuse-waiting"
                    pagination="server"
                    search
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import ExcuseDocumentUpload from './components/ExcuseDocumentUpload.vue'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        ExcuseDocumentUpload
    },
    data(){
        return{
            uploading:false,
            fields:[
                {name:"Personel",key:"Employee.FullName",thClass:"w-20",sortable:true},
                {name:"İzin Türü",key:"EmployeeExcuseType.Name",thClass:"w-20",sortable:true},
                {name:"İzin Başlangıç Tarihi",key:"StartDateTimeStr",thClass:"w-20",sortable:true},
                {name:"İzin Bitiş Tarihi",key:"EndDateTimeStr",thClass:"w-20",sortable:true},
                {name:"Talep Tarihi",key:"RequestDateStr",thClass:"w-20",sortable:true},
            ],
            buttons:[
                { text:"Dosya Yükle",key:"edit",icon:"UploadIcon",variant:"primary",action:this.upload },
            ],
            excuse:{
                Id:null,
                EmployeeId:null,
                ExcuseTypeId:null,
                RequestDate:null,
                StartDateTime:null,
                EndDateTime:null,
                Description:null,
                Approved:null,
                Document:null,
            }
        }
    },
    methods:{
        provider(data){
            return EmployeeOperationsApi.Excuse.GetDocumentWaiting(data)
        },
        clearForm(){
            this.excuse.Id = null
            this.excuse.EmployeeId = null
            this.excuse.ExcuseTypeId = null
            this.excuse.RequestDate = null
            this.excuse.StartDateTime = null
            this.excuse.EndDateTime = null
            this.excuse.Description = null
            this.excuse.Approved = null
            this.excuse.Document = null
        },
        upload(item){
            this.excuse.Id = item.Id
            this.excuse.EmployeeId = item.Employee?.Id || null
            this.excuse.ExcuseTypeId = item.EmployeeExcuseType?.Id || null
            this.excuse.RequestDate = item.RequestDate
            this.excuse.StartDateTime = item.StartDateTime
            this.excuse.EndDateTime = item.EndDateTime
            this.excuse.Description = item.Description
            this.excuse.Approved = item.Approved
            this.excuse.Document = item.Document
            this.$showModal('upload')
        },
        async uploadFile(){
            this.uploading = true
            let formData = await Additional.ToFormData(this.excuse,['Document'])
            EmployeeOperationsApi.Excuse.CreateOrUpdate(formData).then(res=>{
                this.$result(res)
                this.saving = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload')
                }
            }).catch(err=>{
                this.uploading = false
                this.$result(null,err)
            })
        }
    }
}
</script>

<style>

</style>